/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request for special date creation/update
 * @export
 * @interface SpecialDayRequest
 */
export interface SpecialDayRequest {
    /**
     * Unique identifier of the day model
     * @type {string}
     * @memberof SpecialDayRequest
     */
    dayModelId?: string;
    /**
     * start of the special days period
     * @type {string}
     * @memberof SpecialDayRequest
     */
    periodStart?: string;
    /**
     * end of the special days period
     * @type {string}
     * @memberof SpecialDayRequest
     */
    periodEnd?: string;
}

/**
 * Check if a given object implements the SpecialDayRequest interface.
 */
export function instanceOfSpecialDayRequest(value: object): value is SpecialDayRequest {
    return true;
}

export function SpecialDayRequestFromJSON(json: any): SpecialDayRequest {
    return SpecialDayRequestFromJSONTyped(json, false);
}

export function SpecialDayRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecialDayRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dayModelId': json['dayModelId'] == null ? undefined : json['dayModelId'],
        'periodStart': json['periodStart'] == null ? undefined : json['periodStart'],
        'periodEnd': json['periodEnd'] == null ? undefined : json['periodEnd'],
    };
}

export function SpecialDayRequestToJSON(json: any): SpecialDayRequest {
    return SpecialDayRequestToJSONTyped(json, false);
}

export function SpecialDayRequestToJSONTyped(value?: SpecialDayRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dayModelId': value['dayModelId'],
        'periodStart': value['periodStart'],
        'periodEnd': value['periodEnd'],
    };
}

